/* Aviso del inicio: microencuesta sin responder (de ingreso o de Clima Laboral).
 *
 * - No pinta nada si el usuario no tiene ninguna pendiente.
 * - Aparece aunque la haya pospuesto hoy (el modal no se abre solo hasta
 *   mañana, pero la puede completar cuando quiera).
 * - COMPLETAR abre el MicroEncuestaModal (montado en App) por evento; abierta
 *   así, "Más tarde" no descuenta postergaciones.
 * - Al responder, el modal avisa y la tarjeta se oculta.
 */
import { IonButton, useIonViewWillEnter } from "@ionic/react";
import { Typography } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";

import MicroEncuestaAPI, {
  EVENTO_MICROENCUESTA_ABRIR,
  EVENTO_MICROENCUESTA_RESPONDIDA,
  MicroEncuesta,
} from "src/services/microencuesta";

// Tiempo estimado para el texto de la tarjeta (~10 segundos por pregunta).
const SEGUNDOS_POR_PREGUNTA = 10;

const MicroEncuestaCard: React.FC = () => {
  const [encuesta, setEncuesta] = useState<MicroEncuesta | null>(null);

  const cargar = useCallback(() => {
    MicroEncuestaAPI.estado().then((e) => setEncuesta(e.encuesta));
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  // El inicio queda montado: al volver se refresca.
  useIonViewWillEnter(() => {
    cargar();
  }, [cargar]);

  useEffect(() => {
    const onRespondida = () => setEncuesta(null);
    window.addEventListener(EVENTO_MICROENCUESTA_RESPONDIDA, onRespondida);
    return () => window.removeEventListener(EVENTO_MICROENCUESTA_RESPONDIDA, onRespondida);
  }, []);

  if (!encuesta || !(encuesta.preguntas || []).length) return null;

  const cantidad = encuesta.preguntas.length;
  const minutos = Math.max(1, Math.round((cantidad * SEGUNDOS_POR_PREGUNTA) / 60));

  const completar = () =>
    window.dispatchEvent(new CustomEvent<MicroEncuesta>(EVENTO_MICROENCUESTA_ABRIR, { detail: encuesta }));

  return (
    <div className="container mt-1">
      <div
        onClick={completar}
        style={{
          cursor: "pointer",
          background: "#fff",
          borderRadius: 10,
          borderLeft: "6px solid var(--garnet, #910434)",
          boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
          padding: "12px 14px",
          marginBottom: 10,
        }}
      >
        <Typography variant="caption" style={{ color: "var(--garnet, #910434)", fontWeight: 700 }}>
          📝 {encuesta.titulo || "MICROENCUESTA"}
        </Typography>
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          Completá tu microencuesta
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          <span style={{ fontSize: 13, color: "#555" }}>
            Son {cantidad} preguntas, te lleva {minutos} {minutos === 1 ? "minuto" : "minutos"}.
          </span>
          <IonButton
            size="small"
            style={{ "--background": "var(--garnet, #910434)" } as React.CSSProperties}
            onClick={(e) => {
              e.stopPropagation();
              completar();
            }}
          >
            Completar
          </IonButton>
        </div>
      </div>
    </div>
  );
};

export default MicroEncuestaCard;
